import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { TabStateService } from './tab-state.service';

@Component({
  selector: 'fin-tab',
  templateUrl: 'tab.component.html',
  standalone: false,
})
export class TabComponent implements OnInit {
  private service = inject(TabStateService);

  @Input()
  tabId: string;

  selected$: Observable<boolean>;

  ngOnInit(): void {
    this.selected$ = this.service.getSelectedTabId().pipe(map((id) => id === this.tabId));
  }
}
